import React from "react";
// ANT DESIGN COMPONENTS
import { Input, Tooltip } from "antd";
// FONT AWESOME LIBRARY AND ICONS
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";

/**
 * Text input matching the label-above-input layout every Select / InputNumber
 * field in the OPC UA CDO editors already uses (e.g. Security Policy in
 * SecurityEditor): a label span on its own line, then a full-width `large`
 * control below it. Renders as a fragment — the caller keeps the grid-column
 * wrapper (`<div className="col-12 col-md-6 mt-3">`), exactly like those
 * Select fields do — so every field in a row lines up at the same height.
 *
 * `tooltip` mirrors the info-icon pattern MappingsEditor's PositionField
 * already uses for the Floor field: an inline icon at the end of the label,
 * hover reveals the explanation.
 *
 * @fieldWrapper — `scripts/adapterscan.mjs` documents each use of this
 * component as its own field, keyed by its `label`, rather than counting the
 * single Ant Design Input below as one control standing in for all of them.
 */
export default function OpcUaTextField({
  label,
  value,
  onChange,
  required = false,
  disabled = false,
  placeholder = undefined,
  tooltip = undefined,
}: {
  label: string;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  disabled?: boolean;
  placeholder?: string;
  /** Plain text or a richer node (e.g. an `EnumHelpTable`). */
  tooltip?: React.ReactNode;
}) {
  return (
    <>
      {required && <span className="generalStyles__inputFlexRequired">*</span>}
      <span className="generalStyles__inputLabel">
        {label}
        {tooltip && (
          <Tooltip title={tooltip}>
            <FontAwesomeIcon icon={faCircleInfo} className="generalStyles__mlFix" />
          </Tooltip>
        )}
      </span>
      <Input
        className="generalStyles__width100"
        size="large"
        style={{ marginTop: 8 }}
        value={value}
        disabled={disabled}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
      />
    </>
  );
}
